import React, {Fragment} from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {
  getLayoutAnnotationDefaultTableLayout,
  getLayoutAnnotationTableLockedDims,
  LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATABROWSER,
  LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATAEXPLORER,
  setLayoutAnnotationDefaultTableLayout,
  setLayoutAnnotationTableLockedDims
} from "../../utils/annotations";
import { Card, Checkbox, Col, Form, Modal, Radio, Row, Select, Tag } from "antd";
import _ from "lodash";
import {GUTTER_MD, GUTTER_SM, MARGIN_MD, MARGIN_SM, PADDING_MD, SPAN_FULL, SPAN_HALF} from "../../styles/constants";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import DragHandle from "../drag-handle";
import CustomEmpty from "../custom-empty";
import {getHtmlTableString} from "./htmlTable";
import "./style.css";
import DefaultFiltersModal from "./default-filter-modal/DefaultFiltersModal";

export const DROPPABLE_ID_ROW = 'DROPPABLE_ID_ROW';
export const DROPPABLE_ID_COLUMN = 'DROPPABLE_ID_COLUMN';
export const DROPPABLE_ID_FILTER = 'DROPPABLE_ID_FILTER';
export const DROPPABLE_ID_ROW_SECTION = 'DROPPABLE_ID_ROW_SECTION';

class DefaultTableLayout extends React.Component {

  constructor(props) {
    super(props);

    const layoutAnnotationDefaultTableLayout = getLayoutAnnotationDefaultTableLayout(this.props.layoutAnnotations, this.props.annotationsConfig);
    const layoutAnnotationTableLockedDims = getLayoutAnnotationTableLockedDims(this.props.layoutAnnotations, this.props.annotationsConfig);

    const mode = LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATABROWSER;

    const {
      row,
      column,
      rowSection,
      filter,
      filterDefaultValues
    } = layoutAnnotationDefaultTableLayout || this.getDefaultLayout(mode);

    this.state = {
      flagSaveAnnotation: !!layoutAnnotationDefaultTableLayout || (layoutAnnotationTableLockedDims && layoutAnnotationTableLockedDims.length > 0),
      row,
      column,
      rowSection,
      filter,
      mode,
      lockedDims: layoutAnnotationTableLockedDims,
      filterDefaultValues
    };

    this.getDefaultLayout = this.getDefaultLayout.bind(this);
    this.onFlagSaveAnnotationChange = this.onFlagSaveAnnotationChange.bind(this);

    this.onLockedDimsChange = this.onLockedDimsChange.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (props.dsdDimensions) {

      const {
        row,
        column,
        rowSection,
        filter,
        lockedDims,
        filterDefaultValues
      } = state;

      const newFilter = filter.filter(id => props.dsdDimensions.find(dim => dim.id === id))

      return ({
        row: row.filter(id => props.dsdDimensions.find(dim => dim.id === id)),
        column: column.filter(id => props.dsdDimensions.find(dim => dim.id === id)),
        rowSection: [
          ...rowSection.filter(id => props.dsdDimensions.find(dim => dim.id === id)),
          ...props.dsdDimensions
            .filter(dim => ![...row, ...column, ...filter, ...rowSection].find(id => id === dim.id))
            .map(({id}) => id)
        ],
        filter: newFilter,
        filterDefaultValues: _.pickBy(filterDefaultValues, function (value, key) {
          return newFilter.find(id => id === key);
        }),
        lockedDims: lockedDims.filter(id => props.dsdDimensions.find(dim => dim.id === id))
      });
    } else {
      return null;
    }
  }

  componentDidUpdate(prevProps) {

    if (this.props.dsdDimensions && (!prevProps.dsdDimensions || this.props.dsdDimensions.length !== prevProps.dsdDimensions.length)) {
      if (this.state.flagSaveAnnotation) {

        const {
          row,
          column,
          filter,
          rowSection,
          lockedDims,
          filterDefaultValues
        } = this.state;

        const newFilter = filter.filter(id => this.props.dsdDimensions.find(dim => dim.id === id))

        let layoutAnnotations = _.cloneDeep(this.props.layoutAnnotations);

        layoutAnnotations = setLayoutAnnotationDefaultTableLayout(
          layoutAnnotations,
          this.props.annotationsConfig,
          {
            row: row.filter(id => this.props.dsdDimensions.find(dim => dim.id === id)),
            column: column.filter(id => this.props.dsdDimensions.find(dim => dim.id === id)),
            rowSection: [
              ...rowSection.filter(id => this.props.dsdDimensions.find(dim => dim.id === id)),
              ...this.props.dsdDimensions
                .filter(dim => ![...row, ...column, ...filter, ...rowSection].find(id => id === dim.id))
                .map(({id}) => id)
            ],
            filter: newFilter,
            filterDefaultValues: _.pickBy(filterDefaultValues, function (value, key) {
              return newFilter.find(id => id === key);
            })
          }
        );

        layoutAnnotations = setLayoutAnnotationTableLockedDims(
          layoutAnnotations,
          this.props.annotationsConfig,
          lockedDims
        );

        this.props.onChange({layoutAnnotations});
      }
    }

  }

  getDefaultLayout(mode) {
    if (mode === LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATAEXPLORER)
      return ({
        row: [],
        column: [],
        filter: [],
        rowSection: this.props.dsdDimensions
          .sort((a, b) =>
            a.order && b.order && a.order !== b.order
              ? a.order - b.order
              : a.id - b.id)
          .map(({ id }) => id),
        filterDefaultValues: {}
      })
    else
      return ({
        row: [],
        column: [],
        filter: [],
        rowSection: this.props.dsdDimensions
          .sort((a, b) =>
            a.order && b.order && a.order !== b.order
              ? a.order - b.order
              : a.id - b.id)
          .map(({ id }) => id),
        filterDefaultValues: {}
    });
  }

  onFlagSaveAnnotationChange(checked) {

    const {
      row,
      column,
      filter,
      rowSection,
      lockedDims,
      filterDefaultValues
    } = this.state;

    let layoutAnnotations = _.cloneDeep(this.props.layoutAnnotations);

    layoutAnnotations = setLayoutAnnotationDefaultTableLayout(
      layoutAnnotations,
      this.props.annotationsConfig,
      checked
        ? {
          row,
          column,
          filter,
          rowSection,
          filterDefaultValues
        }
        : null
    );

    layoutAnnotations = setLayoutAnnotationTableLockedDims(
      layoutAnnotations,
      this.props.annotationsConfig,
      checked
        ? lockedDims
        : null
    );

    this.props.onChange({layoutAnnotations});

    this.setState({
      flagSaveAnnotation: checked
    });
  }

  onDragEnd(source, destination) {

    if (source && destination) {
      let {
        row,
        column,
        filter,
        rowSection,
        filterDefaultValues
      } = _.cloneDeep(this.state);

      let dragged;

      // When a dimension is dragged out of the filter card, the default value is eliminated
      if (source.droppableId === DROPPABLE_ID_FILTER && destination.droppableId !== DROPPABLE_ID_FILTER) {
        delete filterDefaultValues[filter[source.index]]
      }

      if (source.droppableId === DROPPABLE_ID_ROW) {
        dragged = row[source.index];
        row.splice(source.index, 1)
      } else if (source.droppableId === DROPPABLE_ID_COLUMN) {
        dragged = column[source.index];
        column.splice(source.index, 1);
      } else if (source.droppableId === DROPPABLE_ID_FILTER) {
        dragged = filter[source.index];
        filter.splice(source.index, 1);
      } else {
        dragged = rowSection[source.index];
        rowSection.splice(source.index, 1);
      }

      if (destination.droppableId === DROPPABLE_ID_ROW) {
        row.splice(destination.index, 0, dragged)
      } else if (destination.droppableId === DROPPABLE_ID_COLUMN) {
        column.splice(destination.index, 0, dragged);
      } else if (destination.droppableId === DROPPABLE_ID_FILTER) {
        filter.splice(destination.index, 0, dragged);
      } else {
        rowSection.splice(destination.index, 0, dragged);
      }


      this.props.onChange({
        layoutAnnotations: setLayoutAnnotationDefaultTableLayout(
          _.cloneDeep(this.props.layoutAnnotations),
          this.props.annotationsConfig,
          {
            row,
            column,
            filter,
            rowSection,
            filterDefaultValues
          }
        )
      });

      this.setState({
        row,
        column,
        filter,
        rowSection,
        flagSaveAnnotation: true,
        filterDefaultValues
      });
    }
  }

  onLockedDimsChange(lockedDims) {

    this.props.onChange({
      layoutAnnotations: setLayoutAnnotationTableLockedDims(
        _.cloneDeep(this.props.layoutAnnotations),
        this.props.annotationsConfig,
        lockedDims
      )
    });

    this.setState({
      lockedDims: lockedDims,
      flagSaveAnnotation: true
    });
  }

  render() {
    const {
      t,
      disabled,
      dsdDimensions
    } = this.props;

    const {
      flagSaveAnnotation,
      row,
      column,
      rowSection,
      filter,
      mode,
      lockedDims,
      filterDefaultValues
    } = this.state;
    const Dimension = ({ id, index, defaultValue }) =>
      <Draggable draggableId={id} index={index}>
        {(provided) => (
          <div ref={provided.innerRef} {...provided.draggableProps}>
            <Row type="flex" style={{marginBottom: MARGIN_SM}}>
              <Col span={SPAN_FULL}>
                <Tag
                  style={{
                  width: "100%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                  }}
                  title={defaultValue ? (id + "=" + defaultValue) : (id)}
                >
                   <span {...provided.dragHandleProps}>
                      <DragHandle/>
                    </span>
                  {defaultValue ? (id + "=" + defaultValue) : (id)}
                </Tag>
              </Col>
            </Row>
          </div>
        )}
      </Draggable>;

    const cardStyle = {
      style: {
        height: "100%",
      },
      bodyStyle: {
        minHeight: 120,
        position: "relative",
        padding: 0,
      }
    };

    const droppableStyle = {
      position: "absolute",
      height: "100%",
      width: "100%",
      padding: PADDING_MD,
      overflowY: "auto",
      overflowX: "hidden"
    };

    const filterCard =
      <Card
        className="cardHeaderButton"
        type="inner"
        title={t("components.annotationsForm.layoutAnnotationDefaultTableLayout.cards.filter.title")}
        {...cardStyle}
        extra={
          <DefaultFiltersModal
            className="cardHeaderButton"
            filter={filter}
            filterDefaultValues={filterDefaultValues}
            onChange={
              (filterDict) => {
                this.props.onChange({
                  layoutAnnotations: setLayoutAnnotationDefaultTableLayout(
                    _.cloneDeep(this.props.layoutAnnotations),
                    this.props.annotationsConfig,
                    {
                      row,
                      column,
                      rowSection,
                      filter,
                      filterDefaultValues: filterDict
                    }
                  )
                })
                this.setState({ filterDefaultValues: filterDict })
              }
            }
            dsdDimensions={dsdDimensions}
            cubeId={this.props.cubeId}
            dataflowColumns={this.props.colNames}
            dataflowFilterStr={this.props.filterStr}
          />
        }
      >
        <Droppable droppableId={DROPPABLE_ID_FILTER}>
          {(provided, {isDraggingOver}) => (
            <div {...provided.droppableProps} ref={provided.innerRef} style={droppableStyle}>
              {filter.map((id, index) => <Dimension id={id} key={index} index={index} defaultValue={filterDefaultValues[id]} />)}
              {provided.placeholder}
              {filter.length === 0 && !isDraggingOver &&
              <CustomEmpty
                text={t("components.annotationsForm.layoutAnnotationDefaultTableLayout.cards.placeholder")}/>}
            </div>
          )}
        </Droppable>
      </Card>;

    const rowSectionCard =
      <Card
        type="inner"
        title={t("components.annotationsForm.layoutAnnotationDefaultTableLayout.cards.rowSection.title")}
        {...cardStyle}
      >
        <Droppable droppableId={DROPPABLE_ID_ROW_SECTION}>
          {(provided, {isDraggingOver}) => (
            <div {...provided.droppableProps} ref={provided.innerRef} style={droppableStyle}>
              {rowSection.map((id, index) => <Dimension id={id} key={index} index={index}/>)}
              {provided.placeholder}
              {rowSection.length === 0 && !isDraggingOver &&
              <CustomEmpty
                text={t("components.annotationsForm.layoutAnnotationDefaultTableLayout.cards.placeholder")}/>}
            </div>
          )}
        </Droppable>
      </Card>;

    const columnCard =
      <Card
        type="inner"
        title={t("components.annotationsForm.layoutAnnotationDefaultTableLayout.cards.column.title")}
        {...cardStyle}
      >
        <Droppable droppableId={DROPPABLE_ID_COLUMN}>
          {(provided, {isDraggingOver}) => (
            <div {...provided.droppableProps} ref={provided.innerRef} style={droppableStyle}>
              {column.map((id, index) => <Dimension id={id} key={index} index={index}/>)}
              {provided.placeholder}
              {column.length === 0 && !isDraggingOver &&
              <CustomEmpty
                text={t("components.annotationsForm.layoutAnnotationDefaultTableLayout.cards.placeholder")}/>}
            </div>
          )}
        </Droppable>
      </Card>;

    const rowCard =
      <Card
        type="inner"
        title={t("components.annotationsForm.layoutAnnotationDefaultTableLayout.cards.row.title")}
        {...cardStyle}
      >
        <div style={{height: "100%", backgroundColor: "red"}}>
          <Droppable droppableId={DROPPABLE_ID_ROW}>
            {(provided, {isDraggingOver}) => (
              <div{...provided.droppableProps} ref={provided.innerRef} style={droppableStyle}>
                {row.map((id, index) => <Dimension id={id} key={index} index={index}/>)}
                {provided.placeholder}
                {row.length === 0 && !isDraggingOver &&
                <CustomEmpty
                  text={t("components.annotationsForm.layoutAnnotationDefaultTableLayout.cards.placeholder")}/>}
              </div>
            )}
          </Droppable>
        </div>
      </Card>;

    return (
      <Fragment>
        {!disabled && (
          <Row type="flex" gutter={GUTTER_SM} style={{marginBottom: MARGIN_MD}}>
            <Col>
              {t("components.annotationsForm.layoutAnnotationDefaultTableLayout.flagSaveAnnotation.title")}:
            </Col>
            <Col>
              <Checkbox
                checked={flagSaveAnnotation}
                onChange={e => this.onFlagSaveAnnotationChange(e.target.checked)}
              />
            </Col>
          </Row>
        )}
        <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
          <Col span={SPAN_HALF}>
            <DragDropContext
              onDragEnd={({source, destination}) => this.onDragEnd(source, destination)}
            >
              {mode === LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATAEXPLORER
                ? (
                  <Fragment>
                    <Row gutter={GUTTER_SM} style={{marginBottom: MARGIN_SM}} type="flex">
                      <Col span={SPAN_HALF}>
                        {rowSectionCard}
                      </Col>
                      <Col span={SPAN_HALF}>
                        {rowCard}
                      </Col>
                    </Row>
                    <Row gutter={GUTTER_SM}>
                      <Col span={SPAN_HALF}>
                        {columnCard}
                      </Col>
                    </Row>
                  </Fragment>
                )
                : (
                  <Fragment>
                    <Row gutter={GUTTER_SM} style={{marginBottom: MARGIN_SM}} type="flex">
                      <Col span={SPAN_HALF}>
                        {filterCard}
                      </Col>
                      <Col span={SPAN_HALF}>
                        {rowSectionCard}
                      </Col>
                    </Row>
                    <Row gutter={GUTTER_SM} style={{marginBottom: MARGIN_SM}} type="flex">
                      <Col span={SPAN_HALF}>
                        {rowCard}
                      </Col>
                      <Col span={SPAN_HALF}>
                        {columnCard}
                      </Col>
                    </Row>
                  </Fragment>
                )}
            </DragDropContext>
          </Col>
          <Col span={SPAN_HALF}>
            <Row type="flex" justify="center">
              <Col>
                <Radio.Group
                  disabled={disabled}
                  value={mode}
                  onChange={({ target }) => {

                    const onDataModeChange = (resetLayout) => {

                      if (resetLayout) {
                        const { row, column, rowSection, filter } = this.getDefaultLayout(target.value);
                        this.setState({ row, column, rowSection, filter, mode: target.value });
                      }
                      else
                        this.setState({ mode: target.value });

                      if (flagSaveAnnotation) {
                        this.props.onChange({
                          layoutAnnotations: setLayoutAnnotationDefaultTableLayout(_.cloneDeep(this.props.layoutAnnotations),
                            this.props.annotationsConfig,
                            ({
                              row,
                              column,
                              rowSection,
                              filter
                            })
                          )
                        });
                      }
                    };

                    if (filter.length > 0) {
                      Modal.confirm({
                        title: t("components.annotationsForm.layoutAnnotationDefaultTableLayout.confirms.modeChange.title"),
                        content: t("components.annotationsForm.layoutAnnotationDefaultTableLayout.confirms.modeChange.content"),
                        onOk() {
                          onDataModeChange(true)
                        },
                        cancelText: t('commons.buttons.cancel.title')
                      })
                    } else {
                      onDataModeChange(false)
                    }
                  }}
                >
                  <Radio.Button value={LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATABROWSER}>
                    {t('components.annotationsForm.layoutAnnotationDefaultTableLayout.modeRadio.dataBrowser.title')}
                  </Radio.Button>
                  <Radio.Button value={LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATAEXPLORER}>
                    {t('components.annotationsForm.layoutAnnotationDefaultTableLayout.modeRadio.dataExplorer.title')}
                  </Radio.Button>
                </Radio.Group>
              </Col>
            </Row>
            <Row justify="center" style={{marginTop: MARGIN_MD}}>
              <Col span={SPAN_FULL} style={{overflow: "auto"}}>
                {(row.length !== 0 || column.length !== 0 || rowSection.length !== 0) ? (<div
                  className="html-table"
                  dangerouslySetInnerHTML={{__html: getHtmlTableString(row, column, rowSection)}}
                  style={{maxHeight: 298}}
                />) : (<CustomEmpty text={t("components.annotationsForm.layoutAnnotationDefaultTableLayout.placeholder")} />)}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form className="advanced-form">
              <Form.Item
                label={t('components.annotationsForm.layoutAnnotationDefaultTableLayout.lockedDims.label')}
              >
                <Select
                  disabled={disabled}
                  value={lockedDims}
                  onChange={val => this.onLockedDimsChange(val)}
                  mode="multiple"
                >
                  {(dsdDimensions || []).map(({id}, index) => (
                    <Select.Option
                      key={index}
                      value={id}
                      title={id}
                    >
                      {id}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Fragment>
    );
  }
}

export default compose(
  translate(),
)(DefaultTableLayout);
